.customer-design-system {
  color: var(--lc-text);
  font-family: var(--lc-font-ui);
}

.lc-action,
.lc-icon-action,
.lc-text-action {
  font: 650 var(--lc-type-body) / 1.15 var(--lc-font-ui);
}

.lc-action {
  display: inline-flex;
  min-inline-size: 0;
  max-inline-size: 100%;
  min-height: var(--lc-control-height);
  align-items: center;
  justify-content: center;
  gap: var(--lc-space-2);
  padding: 0.65rem var(--lc-control-pad-inline);
  border: 1px solid transparent;
  border-radius: var(--lc-radius-control);
  box-shadow: 0 5px 12px rgb(34 52 50 / 10%);
  text-align: center;
  overflow-wrap: anywhere;
  text-decoration: none;
  cursor: pointer;
  transition:
    background-color var(--lc-motion-fast) var(--lc-ease-out),
    border-color var(--lc-motion-fast) var(--lc-ease-out),
    box-shadow var(--lc-motion-fast) var(--lc-ease-out),
    transform var(--lc-motion-fast) var(--lc-ease-out);
}

.lc-action > span:not(.lc-action__spinner) {
  min-inline-size: 0;
}

.lc-action > svg,
.lc-action__spinner {
  flex-shrink: 0;
}

.lc-action--large {
  min-height: var(--lc-control-height-large);
  padding-inline: 1.35rem;
  font-size: 1.125rem;
}

.lc-action--primary {
  background: var(--lc-action-primary);
  color: var(--lc-color-porcelain);
}

.lc-action--primary:hover {
  background: var(--lc-action-primary-hover);
}
.lc-action--primary:active:not(:disabled, [aria-disabled="true"]) {
  background: var(--lc-action-primary-pressed);
}

.lc-action--creative {
  background: var(--lc-action-creative);
  color: var(--lc-color-porcelain);
}

.lc-action--creative:hover {
  background: var(--lc-action-creative-hover);
}

.lc-action--creative:active:not(:disabled, [aria-disabled="true"]) {
  background: #072724;
}

.lc-action--secondary {
  border-color: var(--lc-control-border);
  background: var(--lc-action-secondary);
  box-shadow: none;
  color: var(--lc-text-strong);
}

.lc-action--secondary:hover {
  border-color: var(--lc-text-strong);
  background: var(--lc-canvas);
}

.lc-action--secondary:active:not(:disabled, [aria-disabled="true"]) {
  background: var(--lc-surface-subtle);
}

.lc-action--quiet {
  background: transparent;
  box-shadow: none;
  color: var(--lc-link);
}

.lc-action--quiet:hover {
  background: rgb(47 113 128 / 9%);
}

.lc-action--quiet:active:not(:disabled, [aria-disabled="true"]) {
  background: rgb(47 113 128 / 16%);
}

.lc-action--danger {
  border-color: var(--lc-danger);
  background: var(--lc-color-porcelain);
  color: var(--lc-danger);
  box-shadow: none;
}

.lc-action--danger:hover {
  background: #f9e9e6;
}

.lc-action--danger:active:not(:disabled, [aria-disabled="true"]) {
  background: #f2d5d0;
}

.lc-action:active:not(:disabled, [aria-disabled="true"]) {
  transform: translateY(1px);
  box-shadow: 0 2px 5px rgb(34 52 50 / 10%);
}

.lc-action:disabled,
.lc-action[aria-disabled="true"] {
  border-color: #aeb7b4;
  background: var(--lc-disabled-surface);
  box-shadow: none;
  color: var(--lc-disabled-text);
  cursor: not-allowed;
  transform: none;
}

.lc-action__spinner {
  width: 1.05rem;
  height: 1.05rem;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: lc-control-spin 700ms linear infinite;
}

.lc-button-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--lc-space-3);
}

.lc-button-group > .lc-action,
.lc-button-group > .lc-icon-action {
  flex: 0 1 auto;
}

.lc-icon-action {
  position: relative;
  display: inline-grid;
  width: var(--lc-control-height);
  height: var(--lc-control-height);
  flex: 0 0 auto;
  place-items: center;
  padding: 0;
  border: 1px solid var(--lc-control-border);
  border-radius: var(--lc-radius-control);
  background: var(--lc-surface);
  color: var(--lc-text-strong);
  cursor: pointer;
}

.lc-icon-action:hover,
.lc-icon-action[aria-pressed="true"] {
  border-color: var(--lc-color-lake);
  background: rgb(47 113 128 / 9%);
}

.lc-icon-action:active:not(:disabled) {
  border-color: var(--lc-text-strong);
  background: var(--lc-surface-subtle);
  transform: translateY(1px);
}

.lc-icon-action:disabled {
  border-color: #aeb7b4;
  background: var(--lc-disabled-surface);
  color: var(--lc-disabled-text);
  cursor: not-allowed;
  transform: none;
}

/* Existing authenticated consumers keep their native controls while inheriting
 * the governed minimum hit-area contract. */
:where(.customer-home, .book-capability-hub)
  label:has(> input:is([type="checkbox"], [type="radio"])) {
  min-height: var(--lc-control-height);
  align-items: center;
}

:where(.customer-home, .book-capability-hub) .data-rights__danger summary,
:where(.customer-home, .book-capability-hub) .creative-media-account-setting a,
.book-capability-hub .book-home-stage__heading nav a {
  display: inline-flex;
  min-height: var(--lc-control-height);
  align-items: center;
}

:where(.customer-home, .book-capability-hub) .data-rights__danger input {
  min-height: var(--lc-control-height);
}

.lc-action:focus-visible,
.lc-icon-action:focus-visible,
.lc-text-action:focus-visible,
.lc-input:focus-visible,
.lc-check input:focus-visible + .lc-check__mark,
.lc-switch input:focus-visible + .lc-switch__track,
.lc-segmented input:focus-visible + span,
.lc-choice-card input:focus-visible ~ .lc-choice-card__radio,
.lc-upload input:focus-visible ~ span {
  outline: 3px solid var(--lc-focus);
  outline-offset: 3px;
}

.lc-field {
  display: grid;
  min-width: 0;
  gap: 0.4rem;
}

.lc-field__label-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.25rem 1rem;
}

.lc-field__label-row label {
  color: var(--lc-text-strong);
  font-size: var(--lc-type-label);
  font-weight: 700;
}

.lc-field__label-row label > span[aria-hidden="true"] {
  color: var(--lc-danger);
}
.lc-field__optional {
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
  font-weight: 500;
}
.lc-field__count {
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
  font-variant-numeric: tabular-nums;
}

.lc-field__description,
.lc-field__message {
  margin: 0;
  font-size: var(--lc-type-caption);
  line-height: 1.4;
}
.lc-field__description {
  color: var(--lc-text-muted);
}
.lc-field__message {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.lc-field--error .lc-field__message {
  color: var(--lc-danger);
}
.lc-field--success .lc-field__message {
  color: var(--lc-success);
}
.lc-field--warning .lc-field__message {
  color: var(--lc-warning);
}

.lc-input {
  width: 100%;
  min-height: var(--lc-control-height);
  padding: 0.65rem 0.8rem;
  border: var(--lc-field-border-width) solid var(--lc-control-border);
  border-radius: var(--lc-radius-control);
  background: var(--lc-surface);
  color: var(--lc-text);
  font: 500 var(--lc-type-body) / 1.35 var(--lc-font-ui);
  transition:
    border-color var(--lc-motion-fast),
    box-shadow var(--lc-motion-fast);
}

.lc-input::placeholder {
  color: #66716e;
  opacity: 1;
}
.lc-input:hover:not(:disabled) {
  border-color: var(--lc-text-strong);
}
.lc-input:focus-visible {
  border-color: var(--lc-focus);
  box-shadow: 0 0 0 1px var(--lc-focus);
}
.lc-field--error .lc-input {
  border-color: var(--lc-danger);
}
.lc-field--success .lc-input {
  border-color: var(--lc-success);
}
.lc-field--warning .lc-input {
  border-color: var(--lc-warning);
}

.lc-input:disabled {
  border-color: #b9c0bd;
  background: var(--lc-disabled-surface);
  color: var(--lc-disabled-text);
  cursor: not-allowed;
}

.lc-textarea {
  min-height: 9rem;
  resize: vertical;
}
.lc-select-wrap {
  position: relative;
  display: grid;
}
.lc-select {
  padding-inline-end: 2.5rem;
  appearance: none;
}
.lc-select-wrap > svg {
  position: absolute;
  top: 50%;
  right: 0.8rem;
  pointer-events: none;
  transform: translateY(-50%);
}

.lc-check {
  position: relative;
  display: grid;
  min-height: var(--lc-control-height);
  grid-template-columns: 1.35rem minmax(0, 1fr);
  align-items: start;
  gap: 0.65rem;
  color: var(--lc-text);
  cursor: pointer;
}

.lc-check input,
.lc-switch input,
.lc-segmented input,
.lc-choice-card input,
.lc-upload input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.lc-check__mark {
  display: grid;
  width: 1.3rem;
  height: 1.3rem;
  place-items: center;
  margin-top: 0.1rem;
  border: 1.5px solid var(--lc-control-border);
  border-radius: 0.22rem;
  background: var(--lc-surface);
  color: transparent;
}

.lc-check input:checked + .lc-check__mark {
  border-color: var(--lc-color-inkwell);
  background: var(--lc-color-inkwell);
  color: var(--lc-surface);
}
.lc-radio .lc-check__mark {
  border-radius: 50%;
}
.lc-radio input:checked + .lc-check__mark {
  border: 0.35rem solid var(--lc-color-inkwell);
  background: var(--lc-surface);
}
.lc-check strong,
.lc-check small {
  display: block;
}
.lc-check strong {
  font-size: var(--lc-type-label);
  line-height: 1.25;
}
.lc-check small {
  margin-top: 0.15rem;
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
  line-height: 1.35;
}
.lc-check input:disabled ~ * {
  color: var(--lc-disabled-text);
  cursor: not-allowed;
}

.lc-switch {
  position: relative;
  display: grid;
  min-height: var(--lc-control-height);
  grid-template-columns: minmax(0, 1fr) 2.75rem;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

.lc-switch strong,
.lc-switch small {
  display: block;
}
.lc-switch strong {
  color: var(--lc-text-strong);
  font-size: var(--lc-type-label);
}
.lc-switch small {
  margin-top: 0.15rem;
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
}
.lc-switch__track {
  position: relative;
  width: 2.75rem;
  height: 1.55rem;
  border: 1px solid var(--lc-control-border);
  border-radius: 1rem;
  background: #d9dfdc;
}
.lc-switch__track i {
  position: absolute;
  top: 0.16rem;
  left: 0.18rem;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  background: var(--lc-surface);
  box-shadow: 0 1px 4px rgb(34 52 50 / 28%);
  transition: transform var(--lc-motion-fast) var(--lc-ease-out);
}
.lc-switch input:checked + .lc-switch__track {
  border-color: var(--lc-color-inkwell);
  background: var(--lc-color-inkwell);
}
.lc-switch input:checked + .lc-switch__track i {
  transform: translateX(1.2rem);
}

.lc-segmented {
  display: inline-grid;
  min-width: 0;
  grid-auto-flow: column;
  margin: 0;
  padding: 0.22rem;
  border: 1px solid var(--lc-control-border);
  border-radius: var(--lc-radius-control);
  background: var(--lc-surface-subtle);
}

.lc-segmented label {
  position: relative;
  min-height: var(--lc-control-height);
}
.lc-segmented label span {
  display: flex;
  min-height: var(--lc-control-height);
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.45rem 0.75rem;
  border-radius: calc(var(--lc-radius-control) - 0.18rem);
  color: var(--lc-text-muted);
  font-size: var(--lc-type-label);
  font-weight: 650;
  cursor: pointer;
  transition: background-color var(--lc-motion-fast) var(--lc-ease-out);
}
.lc-segmented input:checked + span {
  background: var(--lc-surface);
  box-shadow: 0 2px 7px rgb(34 52 50 / 12%);
  color: var(--lc-text-strong);
}
.lc-segmented:disabled label span {
  cursor: not-allowed;
  color: var(--lc-disabled-text);
}

.lc-choice-card {
  position: relative;
  display: grid;
  min-height: 6rem;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--lc-control-border);
  border-radius: var(--lc-radius-surface);
  background: var(--lc-surface);
  cursor: pointer;
  transition:
    background-color var(--lc-motion-fast) var(--lc-ease-out),
    border-color var(--lc-motion-fast) var(--lc-ease-out);
}

.lc-choice-card:hover,
.lc-choice-card.is-selected {
  border-color: var(--lc-color-lake);
  background: rgb(47 113 128 / 5%);
}
.lc-choice-card:has(input:disabled) {
  border-color: var(--lc-control-border);
  background: var(--lc-disabled-surface);
  cursor: not-allowed;
}
.lc-choice-card__copy strong,
.lc-choice-card__copy small {
  display: block;
}
.lc-choice-card__copy strong {
  color: var(--lc-text-strong);
  font-family: var(--lc-font-display);
  font-size: 1.15rem;
  font-weight: 500;
}
.lc-choice-card__copy small {
  margin-top: 0.3rem;
  color: var(--lc-text-muted);
  line-height: 1.4;
}
.lc-choice-card__radio {
  width: 1.25rem;
  height: 1.25rem;
  border: 1.5px solid var(--lc-control-border);
  border-radius: 50%;
}
.lc-choice-card input:checked ~ .lc-choice-card__radio {
  border: 0.35rem solid var(--lc-color-inkwell);
}

.lc-status {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: start;
  gap: 0.65rem;
  padding: 0.8rem 1rem;
  border-block: 1px solid color-mix(in srgb, currentColor 38%, transparent);
  background: color-mix(in srgb, currentColor 6%, var(--lc-surface));
  color: var(--lc-info);
}

.lc-status--success {
  color: var(--lc-success);
}
.lc-status--warning {
  color: var(--lc-warning);
}
.lc-status--error {
  color: var(--lc-danger);
}
.lc-status > div {
  min-inline-size: 0;
  color: var(--lc-text);
  font-size: var(--lc-type-label);
  line-height: 1.4;
  overflow-wrap: anywhere;
}
.lc-status strong {
  display: block;
  margin-bottom: 0.15rem;
  color: currentColor;
}
.lc-status__action {
  align-self: center;
}

.lc-upload {
  position: relative;
  display: grid;
  min-height: 8rem;
  place-items: center;
  align-content: center;
  gap: 0.5rem;
  padding: 1.25rem;
  border: 1px dashed var(--lc-control-border);
  border-radius: var(--lc-radius-surface);
  background: var(--lc-surface);
  color: var(--lc-color-lake);
  text-align: center;
  cursor: pointer;
}

.lc-upload:hover {
  border-color: var(--lc-color-lake);
  background: rgb(47 113 128 / 5%);
}
.lc-upload strong,
.lc-upload small {
  display: block;
}
.lc-upload strong {
  color: var(--lc-text-strong);
  font-size: var(--lc-type-label);
}
.lc-upload small {
  margin-top: 0.2rem;
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
}

.lc-voice {
  display: flex;
  min-height: var(--lc-control-height);
  align-items: center;
  gap: 0.65rem;
  padding: 0.4rem 0.55rem;
  border: 1px solid rgb(125 138 134 / 56%);
  border-radius: var(--lc-radius-control);
  background: var(--lc-surface);
}
.lc-voice__wave {
  display: flex;
  min-width: 5rem;
  flex: 1;
  align-items: center;
  gap: 0.13rem;
}
.lc-voice__wave i {
  width: 2px;
  height: calc(0.35rem + var(--wave, 0.5rem));
  border-radius: 1px;
  background: var(--lc-color-lake);
  opacity: 0.72;
}
.lc-voice__wave i:nth-child(3n) {
  --wave: 0.8rem;
}
.lc-voice__wave i:nth-child(4n) {
  --wave: 0.25rem;
}
.lc-voice__wave i:nth-child(5n) {
  --wave: 1rem;
}
.lc-voice__time {
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
  font-variant-numeric: tabular-nums;
}
.lc-voice--recording .lc-icon-action {
  border-color: var(--lc-action-primary);
  background: var(--lc-action-primary);
  color: var(--lc-surface);
}
.lc-text-action {
  min-height: var(--lc-control-height);
  padding: 0.3rem;
  border: 0;
  background: transparent;
  color: var(--lc-link);
  text-decoration: underline;
  text-underline-offset: 0.2em;
  cursor: pointer;
}

.lc-progress-steps {
  display: grid;
  grid-template-columns: repeat(var(--steps, 4), minmax(0, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}
.lc-progress-steps li {
  position: relative;
  display: grid;
  justify-items: center;
  gap: 0.4rem;
  padding-inline: 0.5rem;
  text-align: center;
}
.lc-progress-steps li::before {
  position: absolute;
  z-index: 0;
  top: 1.15rem;
  right: 50%;
  left: -50%;
  border-top: 1px solid var(--lc-control-border);
  content: "";
}
.lc-progress-steps li:first-child::before {
  display: none;
}
.lc-progress-steps li > span {
  z-index: 1;
  display: grid;
  width: 2.35rem;
  height: 2.35rem;
  place-items: center;
  border: 1px solid var(--lc-color-lake);
  border-radius: 50%;
  background: var(--lc-surface);
  color: var(--lc-color-lake);
  font-family: var(--lc-font-display);
}
.lc-progress-steps li.is-current > span {
  border-color: var(--lc-action-primary);
  background: var(--lc-action-primary);
  color: var(--lc-surface);
}
.lc-progress-steps li.is-complete > span {
  border-color: var(--lc-success);
  background: var(--lc-success);
  color: var(--lc-surface);
}
.lc-progress-steps strong,
.lc-progress-steps small {
  display: block;
}
.lc-progress-steps strong {
  color: var(--lc-text-strong);
  font-family: var(--lc-font-display);
  font-weight: 500;
}
.lc-progress-steps small {
  margin-top: 0.15rem;
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
}

.lc-labs {
  border: 1px solid rgb(125 138 134 / 55%);
  border-radius: var(--lc-radius-surface);
  background: var(--lc-surface-subtle);
}
.lc-labs > summary {
  display: grid;
  min-height: 4rem;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.7rem;
  padding: 0.7rem 1rem;
  color: var(--lc-text);
  cursor: pointer;
  list-style: none;
}
.lc-labs > summary::-webkit-details-marker {
  display: none;
}
.lc-labs > summary strong,
.lc-labs > summary small {
  display: block;
}
.lc-labs > summary strong {
  color: var(--lc-text-strong);
  font-family: var(--lc-font-display);
  font-size: 1.12rem;
  font-weight: 500;
}
.lc-labs > summary small {
  margin-top: 0.12rem;
  color: var(--lc-text-muted);
  font-size: var(--lc-type-caption);
}
.lc-labs[open] > summary > svg:last-child {
  transform: rotate(180deg);
}
.lc-labs__body {
  padding: 1rem;
  border-top: 1px solid rgb(125 138 134 / 48%);
  background: var(--lc-surface);
}

.lc-dialog {
  position: fixed;
  width: min(38rem, calc(100% - 2rem));
  max-width: none;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  padding: 0;
  overflow: auto;
  overscroll-behavior: contain;
  scroll-padding-block: 1.25rem;
  border: 0;
  border-radius: var(--lc-radius-sheet);
  background: var(--lc-surface);
  box-shadow: var(--lc-shadow-mid);
  color: var(--lc-text);
  animation: lc-dialog-reveal var(--lc-motion-panel) var(--lc-ease-out);
}
.lc-dialog::backdrop {
  background: rgb(15 38 34 / 62%);
}
.lc-dialog--bottom-sheet {
  inset: auto 0 0;
  width: min(48rem, 100%);
  max-height: min(82vh, 52rem);
  max-height: min(82dvh, 52rem);
  margin: 0 auto;
  border-radius: var(--lc-radius-sheet) var(--lc-radius-sheet) 0 0;
  animation-name: lc-dialog-sheet-reveal;
}
.lc-dialog--full-height-sheet {
  inset: 0 0 0 auto;
  width: min(42rem, 100%);
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  margin: 0;
  border-radius: var(--lc-radius-sheet) 0 0 var(--lc-radius-sheet);
  animation-name: lc-dialog-side-reveal;
}
.lc-dialog > header {
  position: sticky;
  z-index: 1;
  top: 0;
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem;
  border-bottom: 1px solid rgb(125 138 134 / 42%);
  background: var(--lc-surface);
}
.lc-dialog h2 {
  margin: 0;
  color: var(--lc-text-strong);
  font: 500 var(--lc-type-heading-sm) / 1.1 var(--lc-font-display);
}
.lc-dialog header p {
  margin: 0.35rem 0 0;
  color: var(--lc-text-muted);
  line-height: 1.45;
}
.lc-dialog__body {
  padding: 1.25rem;
  overflow-wrap: anywhere;
}
.lc-dialog--bottom-sheet .lc-dialog__body {
  padding-bottom: max(1.25rem, env(safe-area-inset-bottom));
  padding-inline: max(1.25rem, env(safe-area-inset-left)) max(1.25rem, env(safe-area-inset-right));
}
.lc-dialog--full-height-sheet > header {
  padding-top: max(1.25rem, env(safe-area-inset-top));
  padding-inline: max(1.25rem, env(safe-area-inset-left)) max(1.25rem, env(safe-area-inset-right));
}
.lc-dialog--full-height-sheet .lc-dialog__body {
  padding-bottom: max(1.25rem, env(safe-area-inset-bottom));
  padding-inline: max(1.25rem, env(safe-area-inset-left)) max(1.25rem, env(safe-area-inset-right));
}

.lc-sticky-action {
  position: sticky;
  z-index: 30;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem max(1rem, env(safe-area-inset-right)) max(0.75rem, env(safe-area-inset-bottom))
    max(1rem, env(safe-area-inset-left));
  border-top: 1px solid rgb(125 138 134 / 42%);
  background: rgb(255 253 252 / 96%);
  box-shadow: 0 -9px 24px rgb(34 52 50 / 10%);
}

@keyframes lc-control-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes lc-dialog-reveal {
  from {
    opacity: 0.94;
    transform: translateY(0.25rem);
  }
}

@keyframes lc-dialog-sheet-reveal {
  from {
    opacity: 0.94;
    transform: translateY(0.75rem);
  }
}

@keyframes lc-dialog-side-reveal {
  from {
    opacity: 0.94;
    transform: translateX(0.75rem);
  }
}

@media (max-width: 40rem) {
  .lc-action--large {
    width: 100%;
  }
  .lc-status {
    grid-template-columns: auto minmax(0, 1fr);
  }
  .lc-status__action {
    grid-column: 2;
  }
  .lc-progress-steps {
    gap: 0.15rem;
  }
  .lc-progress-steps li {
    padding-inline: 0.15rem;
  }
  .lc-progress-steps small {
    display: none;
  }
  .lc-sticky-action {
    align-items: stretch;
    flex-direction: column;
  }
  .lc-sticky-action .lc-action {
    width: 100%;
  }
  .lc-dialog--full-height-sheet {
    inset: 0;
    width: 100%;
    border-radius: 0;
  }
}

@media (forced-colors: active) {
  .lc-action,
  .lc-icon-action,
  .lc-input,
  .lc-check__mark,
  .lc-switch__track,
  .lc-choice-card,
  .lc-upload,
  .lc-status,
  .lc-labs,
  .lc-dialog {
    border: 1px solid CanvasText;
  }
  .lc-dialog {
    background: Canvas;
    color: CanvasText;
    box-shadow: none;
  }
  .lc-dialog::backdrop {
    background: Canvas;
    opacity: 0.72;
  }
  .lc-dialog > header {
    border-color: CanvasText;
    background: Canvas;
  }
  .lc-action {
    background: ButtonFace;
    color: ButtonText;
    forced-color-adjust: auto;
  }
  .lc-action:focus-visible,
  .lc-icon-action:focus-visible,
  .lc-input:focus-visible {
    outline: 3px solid Highlight;
  }
  .lc-action:disabled,
  .lc-icon-action:disabled,
  .lc-input:disabled {
    color: GrayText;
  }

  .lc-action:disabled,
  .lc-icon-action:disabled {
    border-style: dashed;
  }

  .lc-action[aria-busy="true"],
  .lc-icon-action[aria-busy="true"] {
    border-style: dotted;
  }

  .lc-action:active:not(:disabled, [aria-disabled="true"]),
  .lc-icon-action:active:not(:disabled),
  .lc-icon-action[aria-pressed="true"] {
    border-width: 3px;
    border-color: Highlight;
    background: Highlight;
    color: HighlightText;
  }

  .customer-mobile-nav a[aria-current="page"] {
    outline: 2px solid Highlight;
    outline-offset: -3px;
  }

  .app-header--customer a:focus-visible,
  .app-header--customer .customer-account-menu__trigger:focus-visible,
  .customer-mobile-nav a:focus-visible {
    outline: 4px double Highlight;
    outline-offset: -1px;
  }

  .lc-progress-steps li.is-current > span {
    border-width: 3px;
  }

  :where(.customer-home, .book-capability-hub) .customer-book-facts > span,
  :where(.customer-home, .book-capability-hub) .customer-book-cover,
  :where(.customer-home, .book-capability-hub) .customer-book-cover small {
    border: 1px solid CanvasText;
    background: Canvas;
    color: CanvasText;
  }

  .customer-home .customer-book-cover small,
  .book-capability-hub .customer-book-cover small {
    color: CanvasText;
    forced-color-adjust: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .lc-action,
  .lc-choice-card,
  .lc-segmented label span,
  .lc-switch__track i {
    transition-duration: 0.01ms;
  }
  .lc-action__spinner {
    animation: none;
  }
  .lc-dialog {
    animation: none;
    scroll-behavior: auto;
  }
}
.cover-feedback {
  display: grid;
  gap: var(--lc-space-3, 0.75rem);
  margin-block: var(--lc-space-4, 1rem);
}

.cover-feedback__references {
  display: flex;
  flex-wrap: wrap;
  gap: var(--lc-space-3, 0.75rem);
  padding: var(--lc-space-3, 0.75rem);
  border: 1px solid var(--lc-border, #d9d2c3);
  border-radius: var(--lc-radius-surface, 0.875rem);
}

.cover-feedback__reference {
  display: inline-flex;
  align-items: center;
  gap: var(--lc-space-2, 0.5rem);
  min-block-size: 44px;
}
